import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function TechnicalData() {
  const specifications = [{
    label: 'An construcție',
    value: '2011'
  }, {
    label: 'Structură',
    value: 'Beton armat'
  }, {
    label: 'Lift',
    value: 'Modern, cu acces la ambele corpuri'
  }, {
    label: 'Utilități',
    value: 'Complete (apă, gaz, electricitate, internet)'
  }, {
    label: 'Certificat energetic',
    value: 'Clasa A'
  }, {
    label: 'Stare',
    value: 'Complet funcțional'
  }];
  return <section className="py-20 px-6 md:px-12 lg:px-16 bg-gray-50" data-id="element-470">
      <div className="max-w-7xl mx-auto" data-id="element-471">
        <h2 className="text-3xl md:text-4xl font-bold text-[#121c53] text-center mb-12" data-id="element-472">
          Date Tehnice & Conformitate
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-473">
          {specifications.map((spec, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-474">
              <div className="flex items-start gap-3" data-id="element-475">
                <CheckCircle2Icon className="w-5 h-5 text-[#357beb] flex-shrink-0 mt-1" data-id="element-476" />
                <div data-id="element-477">
                  <p className="text-sm text-gray-600 mb-1" data-id="element-478">{spec.label}</p>
                  <p className="font-semibold text-[#121c53] text-lg" data-id="element-479">
                    {spec.value}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-12 bg-gradient-to-r from-[#121c53] to-[#1a2a70] p-8 rounded-2xl text-center" data-id="element-480">
          <p className="text-white text-xl font-semibold" data-id="element-481">
            ✓ Toate certificatele și autorizațiile în regulă
          </p>
        </div>
      </div>
    </section>;
}